import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { act } from "@/lib/hooks";
import { api, fmt } from "@/lib/api";
import { Field, NativeSelect } from "@/components/common";

// Moves an opportunity's stage and handles the On Won outcome (draft quote / job / link prompt).
export function useStageMove(reload) {
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState(null);
  const move = async (id, stage) => {
    const r = await act(() => api.patch(`/crm/opportunities/${id}/stage`, { stage }));
    if (!r) return;
    if (r.won_action === "quote_created") toast.success(`Won! Draft quote ${r.quote.number} created`, { action: { label: "Open", onClick: () => navigate(`/app/quotes/${r.quote.id}`) } });
    if (r.won_action === "job_created") toast.success(`Won! Draft job ${r.job.number} created`, { action: { label: "Open", onClick: () => navigate(`/app/jobs/${r.job.id}`) } });
    if (r.won_action === "no_customer") toast.warning(r.message);
    if (r.won_action === "prompt_link") setPrompt({ oid: id, quotes: r.quotes, message: r.message, quote_id: r.quotes[0].id });
    reload();
  };
  const dialog = <LinkPrompt prompt={prompt} setPrompt={setPrompt} reload={reload} />;
  return { move, dialog };
}

function LinkPrompt({ prompt, setPrompt, reload }) {
  const navigate = useNavigate();
  const link = async () => { if (await act(() => api.post(`/crm/opportunities/${prompt.oid}/link-quote`, { quote_id: prompt.quote_id }), "Quote linked to opportunity")) { setPrompt(null); reload(); } };
  const create = async () => { const q = await act(() => api.post(`/crm/opportunities/${prompt.oid}/create-quote`), "Draft quote created"); if (q) { setPrompt(null); navigate(`/app/quotes/${q.id}`); } };
  return (
    <Dialog open={!!prompt} onOpenChange={() => setPrompt(null)}>
      <DialogContent data-testid="won-link-dialog">
        <DialogHeader><DialogTitle>Opportunity won</DialogTitle><DialogDescription>{prompt?.message}</DialogDescription></DialogHeader>
        {prompt && <Field label="Customer's quotes"><NativeSelect testId="won-link-quote-select" className="w-full" value={prompt.quote_id} onChange={(v) => setPrompt({ ...prompt, quote_id: v })}
          options={prompt.quotes.map((q) => ({ value: q.id, label: `${q.number} · ${q.title} · ${q.status} · ${fmt(q.totals?.total)}` }))} /></Field>}
        <DialogFooter className="gap-2">
          <Button variant="outline" data-testid="won-create-new-quote" onClick={create}>Create new draft instead</Button>
          <Button data-testid="won-link-confirm" onClick={link}>Link selected quote</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
